import Vue from "vue";
import Vuex from "vuex";
// import { omit } from 'ramda';

import { Toast } from "mint-ui";

Vue.use(Vuex);

// 创建Vuex对象
const store = new Vuex.Store({
  state: {
    // 用户信息
    userInfo: {},
    // 活动数据
    activeInfo: {},

    // 泰国蜗牛大富翁活动才有↓
    diceInfo: {},
    AppointInfo: {},
    // ↑

    // 弹窗类
    // 登陆弹窗
    isShowLogin: false,
    // 角色选择弹窗
    isShowOs: false,
    pageLanguage: "zh"
  },
  getters: {},
  mutations: {
    // 设置用户信息
    setUserInfo(state, userInfo = {}) {
      state.userInfo = userInfo;
    },
    // 初始化用户信息
    setInitUserInfo(state, userInfo = {}) {
      state.userInfo = Object.assign({}, userInfo);
    },
    // 设置活动信息
    setActiveInfo(state, activeInfo = {}) {
      state.activeInfo = activeInfo;
    },
    // 初始化活动信息
    setInitActiveInfo(state, activeInfo = {}) {
      state.activeInfo = Object.assign({}, activeInfo);
    },
    // 修改登陆弹窗
    changeLoginPopup(state, val) {
      val = val ? true : false;
      state.isShowLogin = val;
    },
    // 修改角色选择弹窗
    changeOsPopup(state, val) {
      state.isShowOs = typeof val === "boolean" ? val : !state.isShowOs;
    },
    // 泰国蜗牛大富翁活动才有↓
    // 最新需要执行的参数
    updatedDiceInfo(state, payload) {
      state.diceInfo = { ...payload };
    },
    // 再次执行时候需要返回的参数
    updatedAppointInfo(state, payload) {
      state.AppointInfo = { ...payload };
    },
    // 设置页面语言
    updatePageLanguage(state, val) {
      state.pageLanguage = val;
      localStorage.setItem('Language', val);
    },
    // ↑
  },
  actions: {
    // 获取初始数据
    onInitDataCallback({ state, commit }, response = {}, config = {}) {
      const { needAccount = true, needUpdateInfo = true } = config || {};
      // 开启登陆弹窗
      if (Number(response.code) === 401 && needAccount) {
        // 暂时关闭
        commit("changeLoginPopup", true);
      }
      // 设置用户信息
      if (Number(response.code) === 200 && needUpdateInfo) {
        const { userinfo = {}, activity = {} } = response.data || {};
        commit("setUserInfo", userinfo);
        commit("setActiveInfo", activity);
      }

      // 500的错误提示信息
      if (Number(response.code) === 500 || Number(response.code) === 403) {
        Toast({
          message: response.message,
          duration: 1000,
          className: "toasts"
        });
      }

      return response;
    },
    setShare() {
      return Promise.resolve();
    },

    // 泰国蜗牛大富翁活动才有↓
    setDiceInfo({ commit }, payload) {
      commit("updatedDiceInfo", payload);
    },
    setAppointInfo({ commit }, payload) {
      commit("updatedAppointInfo", payload);
    },
    // 设置页面语言
    setPageLanguage({ commit }, payload) {
      commit("updatePageLanguage", payload);
    },
    // ↑
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/active.js